module.exports = __webpack_public_path__ + "static/media/logoTagline.57cfa726.png";